/**
 * 타임아웃으로 Teams AuthToken 확보에 실패한 에러입니다.
 */
export default class TeamsAuthTokenTimeoutError extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
  }
}
